import { useMemo } from 'react';
import { t } from '@lingui/core/macro';
import upperFirst from 'lodash-es/upperFirst.js';
import { ChevronDown, CircleCheck, X } from 'lucide-react';
import { Button, Menu, MenuButton, MenuItem, MenuList, Box } from '@chakra-ui/react';
import {
  AssessmentOutcomeSchema,
  type AssessmentOutcome,
} from '@duke-hq/svc-api-db/schemas/enums/AssessmentOutcome.schema';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';

import { iconSize } from '@duke-hq/ui/constants/scalable';

function formatOutcomeLabel(outcome: string): string {
  return upperFirst(outcome.replace(/_/g, ' ').toLowerCase());
}

export default function OutcomeFilter() {
  const { filters, updateFilters } = useFiltersContext();
  const outcome = filters.outcome;

  const setOutcome = (next: AssessmentOutcome | undefined) => {
    updateFilters({ outcome: next });
  };

  const label = useMemo(() => {
    return outcome != null ? formatOutcomeLabel(outcome) : t`Status`;
  }, [outcome]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        width="auto"
        colorScheme="gray"
        px={2}
        rightIcon={
          outcome != null ? (
            <Box
              minW="fit-content"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                setOutcome(undefined);
              }}
              ml={1}
            >
              <X size={iconSize.md} />
            </Box>
          ) : (
            <ChevronDown size={iconSize.md} />
          )
        }
        leftIcon={<CircleCheck size={iconSize.md} />}
      >
        {label}
      </MenuButton>
      <MenuList>
        {AssessmentOutcomeSchema.options.map((option: AssessmentOutcome) => (
          <MenuItem
            key={option}
            onClick={() => {
              setOutcome(option);
            }}
          >
            {formatOutcomeLabel(option)}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
